export enum ToggleSwitchIconNameEnum {
  ToggleSwitchOn = 'check',
  ToggleSwitchOff = 'close',
}
